module.exports = __webpack_public_path__ + "img/cover-game-04.420bbdc9.jpg";